module.exports = __webpack_public_path__ + "static/media/RecursosMat-ensinoMed-curto.58defe91.png";